import React from 'react';
import styled from 'styled-components';

import { colors, transition } from '../../utils/styles';

import { LinkButton } from '../commons';

const { GATSBY_MANAGER_URL } = process.env;

const TopBanner = styled.div`
  width: 100%;
  background-image: ${ ({ isEngagementPage }) =>
    isEngagementPage
      ? 'linear-gradient(to top, #ffffff, #ffa100)'
      : 'linear-gradient(#00a7ff, white)' };
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TopBannerWrapper = styled.div`
  width: 100%;
  padding-top: 100px;
  text-align: center;
  @media (max-width: 900px) {
    padding-top: 104px;
  }
`;

const BannerHeadingWrapper = styled.div`
  font-size: 25px;
  line-height: 1.2;

  @media (min-width: 901px) {
    font-size: 45px;
    line-height: 1.24;
  }
`;

const BannerHeading = styled.h1`
  color: white;
  font-weight: bold;
  padding: 0 15%;

  @media (max-width: 900px) {
    padding: 0 10%;
  }
`;

const SubHeading = styled.h2`
  color: white;
  font-size: 15px;
  line-height: 1.4;
  padding-top: 20px;
  width: 290px;
  margin: 0 auto;
  text-transform: none;
  font-weight: normal;

  @media (min-width: 901px) {
    font-size: 25px;
    line-height: normal;
    padding-top: 20px;
    width: 100%;
  }
`;

const TryItTodayBtn = styled.div`
  margin: 30px auto;
  width: 174px;
  height: 42px;
  border-radius: 25px;
  background-color: white;
  color: #01a7ff;
  line-height: 2.8;
  font-size: 15px;
  font-weight: 700;

  &:after {
    content: 'Try it today';
  }

  &:hover {
    background-color: ${ colors.mainBlue };
    color: white;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15);
  }

  ${ transition('all 0.3s ease') };
`;

const TopBannerImage = styled.img`
  transform: ${ props =>
    props.isEngagementPage ? 'translateX(-20px)' : 'none' };
  object-fit: contain;
  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

const HeaderIcon = styled.img`
  height: 60px;
  width: 60px;
`;

export default props => (
  <TopBanner isEngagementPage={ props.engagementPage }>
    <TopBannerWrapper>
      <BannerHeadingWrapper>
        { props.headerIconSrcSet && (
          <HeaderIcon srcSet={ props.headerIconSrcSet } />
        ) }
        { props.heading && <BannerHeading> { props.heading } </BannerHeading> }
      </BannerHeadingWrapper>
      <SubHeading> { props.subHeading } </SubHeading>
      <LinkButton
        href={ `${ GATSBY_MANAGER_URL }/signup` }
        text={ props.buttonText }
        id={ `${ props.source }_top_banner_cta` }
      />
    </TopBannerWrapper>
    <TopBannerImage
      isEngagementPage={ props.engagementPage }
      srcSet={ props.bannerImageSrcSet }
    />
  </TopBanner>
);



// WEBPACK FOOTER //
// ./src/components/products/topBanner.js